// /FRONTEND/src/service/dashboardServices/dashboardCount.services.js

import axios from "axios";

//Env varibale.

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const studentAndAttendanceAndAbsenteeCallingCount= async (payload) => {

    console.log(payload)

    try {
        
        const response = await axios.post(`${API_BASE_URL}/api/attendance-count`, payload);
       
        console.log(response.status)
        return response.data
    } catch (error) {
        
        console.log('error occured while fetching studentAndAttendanceAndAbsenteeCallingCount')
        console.log(error)
    }

}


//Attendance pdf count api



export const attendancePdfUploadStatusCountByClass= async (payload) => {

    console.log(payload)

    try {
        
        const response = await axios.post(`${API_BASE_URL}/api/attendance-pdf-count`, payload);
       
        console.log(response.status)
        return response.data
    } catch (error) {
        
        console.log('error occured while fetching studentAndAttendanceAndAbsenteeCallingCount')
        console.log(error)
    }

}



//V2 API


export const PresentAbsentCallingDashboard= async (payload) => {

    console.log(payload)

    try {
        
        const response = await axios.post(`${API_BASE_URL}/api/totalstudent-present-absent-calling-count`, payload);
       
        console.log(response.status)
        return response.data
    } catch (error) {
        
        console.log('error occured while fetching studentAndAttendanceAndAbsenteeCallingCount')
        console.log(error)
    }

}








export const uploadedAttendancePdfDashboard= async (payload) => {

    console.log(payload)

    try {
        
        const response = await axios.post(`${API_BASE_URL}/api/uploaded-attendance-pdf-dashboard`, payload);
       
        console.log(response.status)
        return response.data
    } catch (error) {
        
        console.log('error occured while fetching uploaded attendance pdf dashboard')
        console.log(error)
    }

}